const backgroundColor = '#383838';

export { backgroundColor };
